<template>
    <div>
        <h2>Delivery</h2>

        <delivery-overrides :data="data.other_deliveries"
                            :agents="data.agents"
                            :employer_id="data.employer_id"
        ></delivery-overrides>

        <div class="row">
            <div class="col-sm-3"></div>
            <div class="col-sm-6">
                <div class="l-content">
                    <h3>ATS Integration setting</h3>
                    <div class="form-group">
                        <label>ATS Integration</label>
                        <select v-model="myData.fallback.agent" class="form-control">
                            <option v-for="agent in data.agents" :value="agent.id">{{ agent.name }}</option>
                        </select>
                    </div>
                    <component v-if="currentAgent && currentAgent.component" :is="currentAgent.component" :data="myData.fallback.data"></component>
                    <btn class="btn btn-primary" :click="save">Save</btn>
                </div>
            </div>
            <div class="col-sm-3"></div>
        </div>

        <employer-notes-wrapper :employer-id="employerId" />
    </div>
</template>

<script>
import DeliveryOverrides from "./delivery-overrides";

export default {
    components: {DeliveryOverrides},
    props: [
        'data',
        'employerId',
    ],
    data() {
        return {
            show_dialogs: {},
            myData: this.data,
            test: ''
        };
    },
    computed: {
        currentAgent() {
            return _.find(this.data.agents, (r) => r.id == this.data.fallback.agent);
        }
    },
    methods: {
        save() {
            return axios.post(url(`admin/employer/${this.data.employer_id}/delivery/store-fallback`), {
                data: this.data.fallback
            })
        }
    }
}
</script>
